export const ReloadPage = {
  mounted() {
    // Prevent text selection on mousedown to avoid drag interfering with click
    this.mousedownListener = (e) => {
      e.preventDefault()
    }

    // Handle the actual reload on click
    this.clickListener = (e) => {
      e.preventDefault()
      window.location.reload()
    }

    this.el.addEventListener("mousedown", this.mousedownListener)
    this.el.addEventListener("click", this.clickListener)
  },

  destroyed() {
    this.el.removeEventListener("mousedown", this.mousedownListener)
    this.el.removeEventListener("click", this.clickListener)
  },
}
